import { ca } from '@cian/analytics';

export function trackPanoramaShow(objectType?: string) {
  ca('eventSite', {
    action: 'panorama',
    category: 'Infrastructure',
    label: 'show_sopr',
    name: 'oldevent',
    page: {
      pageType: 'Card',
      siteType: 'desktop',
      extra: {
        object_type: objectType,
      },
    },
    useLastProducts: true,
  });
}
